module.exports = __webpack_public_path__ + "files/bb15c9cb52ff9e1b12a11c3d45338a1f.svg";